var bittoelatings_h = [{
    rule: "pasgemaaktelae:create",
    bitmask: "1",
    blok: 7,
    beskrywing: "Skep van pasgemaakte lae",
    groepe: ["pasgemaaktelae", "dashboard"],
},
{
    rule: "pasgemaaktelae:read",
    bitmask: "2",
    blok: 7,
    beskrywing: "Lees van pasgemaakte lae",
    groepe: ["pasgemaaktelae", "dashboard"],
},
{
    rule: "pasgemaaktelae:update",
    bitmask: "4",
    blok: 7,
    beskrywing: "Verander pasgemaakte lae",
    groepe: ["pasgemaaktelae", "dashboard"],
},
{
    rule: "pasgemaaktelae:delete",
    bitmask: "8",
    blok: 7,
    beskrywing: "Verwyder van pasgemaakte lae",
    groepe: ["pasgemaaktelae", "dashboard"],
},
{
    rule: "pasgemaaktelaenuweweergawe:create",
    bitmask: "16",
    blok: 7,
    beskrywing: "Skep van nuwe weergawe van pasgemaakte lae",
    groepe: ["pasgemaaktelaenuweweergawe", "dashboard"],
},
{
    rule: "pasgemaaktelaenuweweergawe:read",
    bitmask: "32",
    blok: 7,
    beskrywing: "Lees van nuwe weergawe van pasgemaakte lae",
    groepe: ["pasgemaaktelaenuweweergawe", "dashboard"],
},
{
    rule: "pasgemaaktelaenuweweergawe:update",
    bitmask: "64",
    blok: 7,
    beskrywing: "Verander nuwe weergawe van pasgemaakte lae",
    groepe: ["pasgemaaktelaenuweweergawe", "dashboard"],
},
{
    rule: "pasgemaaktelaenuweweergawe:delete",
    bitmask: "128",
    blok: 7,
    beskrywing: "Verwyder nuwe weergawe van van pasgemaakte lae",
    groepe: ["pasgemaaktelaenuweweergawe", "dashboard"],
},
{
    rule: "pasgemaaktelaedata:create",
    bitmask: "256",
    blok: 7,
    beskrywing: "Skryf van beskrywing vir pasgemaakte laag items",
    groepe: ["pasgemaaktelaedata", "dashboard"]
},
{
    rule: "pasgemaaktelaedata:read",
    bitmask: "512",
    blok: 7,
    beskrywing: "Lees van beskrywing vir pasgemaakte laag items",
    groepe: ["pasgemaaktelaedata", "dashboard"]
},
{
    rule: "pasgemaaktelaedata:update",
    bitmask: "1024",
    blok: 7,
    beskrywing: "Verander beskrywing vir pasgemaakte laag items",
    groepe: ["pasgemaaktelaedata", "dashboard"]
},
{
    rule: "pasgemaaktelaedata:delete",
    bitmask: "2048",
    blok: 7,
    beskrywing: "Verwyder beskrywing vir pasgemaakte laag items",
    groepe: ["pasgemaaktelaedata", "dashboard"]
},
];

export default bittoelatings_h;